import { createFileRoute } from '@tanstack/react-router';
import { ProtectedStatusConsole } from '@/features/hr/ProtectedStatusConsole';

/**
 * Status protetti (HR) — dati particolari ex art. 9 GDPR: L.104, categorie protette,
 * genitorialità, cariche sindacali ed elettive, donazioni, diritto allo studio.
 * Il BE traccia anche le letture e nega l'accesso ai manager; i due status sensibili
 * richiedono i claim `hr.protected.sensitive.read/.write`.
 */
export const Route = createFileRoute('/_app/hr/protected-statuses')({ component: ProtectedStatusConsole });
